export const sliderPagination = (el) => {
  return {
    el,
    bulletClass: 'slider-pagination__item',
    bulletActiveClass: 'slider-pagination__item--active'
  }
}

export const sliderNavigation = (navigationClass) => {
  const navigation = document.querySelector(`.${navigationClass}`)
  if(navigation) {
    const prevEl = navigation.querySelector('.slider-navigation__button--prev')
    const nextEl = navigation.querySelector('.slider-navigation__button--next')

    if(prevEl && nextEl) {
      return {
        nextEl, prevEl
      }
    }
  }
}
